export function getPgCnt(number = 10) {
  const pageSize = localStorage.getItem(
    `paginationPageSize-${this.$options.name}`
  )
  return Number(pageSize) || number
}
